import React from 'react'
import { Row, Col } from 'react-bootstrap'

export default function EnrolmentPanel (props){
  const { enrolmentNumber } = props
  return(
    <Row>
      <Col lg={12} xs={12} className="rd-text">
        <div className="roster-metric-chips">
          <div className="roster-metric-chip">
            <span className="roster-metric-chip-label">Enrolled</span>
            <span className="roster-metric-chip-value">{enrolmentNumber.enrolled}</span>
          </div>
          <div className="roster-metric-chip">
            <span className="roster-metric-chip-label">Maximum</span>
            <span className="roster-metric-chip-value">{enrolmentNumber.max}</span>
          </div>
          <div className="roster-metric-chip">
            <span className="roster-metric-chip-label">Flex</span>
            <span className="roster-metric-chip-value">{enrolmentNumber.flex}</span>
          </div>
        </div>
      </Col>
    </Row>

  )
}
